/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfCustomerFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfCustomer } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/customers/matches
 */
export interface MatchesRequestBuilder extends BaseRequestBuilder<MatchesRequestBuilder> {
    /**
     * Find potential customer matches based on company name, email address, or address
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfCustomer>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<MatchesRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfCustomer | undefined>;
    /**
     * Find potential customer matches based on company name, email address, or address
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<MatchesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Find potential customer matches based on company name, email address, or address
 */
export interface MatchesRequestBuilderGetQueryParameters {
    address?: string;
    companyName?: string;
    emailAddress?: string;
}
/**
 * Uri template for the request builder.
 */
export const MatchesRequestBuilderUriTemplate = "{+baseurl}/api/customers/matches{?address*,companyName*,emailAddress*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const MatchesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: MatchesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfCustomerFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
